import { useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { ProjectDto } from '../application/dto/ProjectDto';
import { ProjectStatusBadge } from './ProjectStatusBadge';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import './ProjectDetailPage.css';

export function ProjectDetailPage() {
  const project = useLoaderData() as ProjectDto;
  useDocumentHead(project.seo);

  return (
    <Container>
      <article className="dma-project-detail">
        <img
          className="dma-project-detail__cover"
          src={project.coverImage}
          alt={project.name}
          loading="lazy"
        />
        <ProjectStatusBadge status={project.status} />
        <h1>{project.name}</h1>
        <p className="dma-project-detail__location">
          {project.province && project.city
            ? `${project.province} · ${project.city}`
            : project.province || project.city || 'موقعیت جغرافیایی: هنوز ثبت نشده است'}
        </p>
        <p className="dma-project-detail__description">{project.description}</p>

        {project.minerals.length > 0 ? (
          <div className="dma-project-detail__section">
            <h2>مواد معدنی</h2>
            <ul>
              {project.minerals.map((mineral) => (
                <li key={mineral}>{mineral}</li>
              ))}
            </ul>
          </div>
        ) : null}

        {project.technicalSpecifications.length > 0 ? (
          <div className="dma-project-detail__section">
            <h2>مشخصات فنی</h2>
            <dl className="dma-project-detail__specs">
              {project.technicalSpecifications.map((spec) => (
                <div key={spec.label}>
                  <dt>{spec.label}</dt>
                  <dd>{spec.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ) : null}
      </article>
    </Container>
  );
}
